import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgbModule, NgbTooltipConfig } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { CalendarDateFormatter, CalendarModule, CalendarMomentDateFormatter, DateAdapter, MOMENT } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/moment';
import moment from 'moment';
import { QuillModule } from 'ngx-quill';
import { NgSignaturePadModule } from '../ng-signaturepad/ng-signaturepad.module';
import { AlertComponent } from './alert/alert.component';
import { CalendarComponent } from './calendar/calendar.component';
import { CommentComponent } from './comment/comment.component';
import { ConfirmationComponent } from './confirmation/confirmation.component';
import { DatepickerComponent } from './datepicker/datepicker.component';
import { ConfirmEqualValidatorDirective } from './directives/confirm-equal-validator.directive';
import { ExternalLinkDirective } from './directives/external-link.directive';
import { InputNumbersOnlyDirective } from './directives/input-numbers-only.directive';
import { TitleTemplateDirective } from './dynamic-form/directives/templates.directive';
import { DynamicFormComponent } from './dynamic-form/dynamic-form.component';
import { EmailComposerComponent } from './email-composer/email-composer.component';
import { FileInputComponent } from './file-input/file-input.component';
import { MailingConfirmationComponent } from './mailing confirmation/mailing-confirmation.component';
import { MailingComposerComponent } from './mailing-composer/mailing-composer.component';
import { NgSelectMultiLabelTmpComponent } from './ng-select-multi-label-tmp/ng-select-multi-label-tmp.component';
import { NumericTextboxComponent } from './numeric-textbox/numeric-textbox.component';
import { HasPermissionDirective } from './permissions/has-permission.directive';
import { AgePipe } from './pipe/age.pipe';
import { DisplayLabelSortPipe } from './pipe/display-label-sort.pipe';
import { FilterStageTypePipe } from './pipe/filter-stage-type.pipe';
import { PhonePipe } from './pipe/phone.pipe';
import { PrintTimePipe } from './pipe/print-time.pipe';
import { SiretPipe } from './pipe/siret.pipe';
import { TimePipe } from './pipe/time.pipe';
import { UniqueNaturePipe } from './pipe/unique-nature.pipe';
import { SignatureComponent } from './signature/signature.component';
import { SmsComposerComponent } from './sms-composer/sms-composer.component';
import { SortableDirective } from './sortable/sortable.directive';
import { TextEditorComponent } from './text-editor/text-editor.component';
import { ToastsContainerComponent } from './toast/toasts-container.component';

export function momentAdapterFactory() {
  return adapterFactory(moment);
}

@NgModule({
  declarations: [
    AgePipe,
    AlertComponent,
    CalendarComponent,
    CommentComponent,
    ConfirmationComponent,
    ConfirmEqualValidatorDirective,
    DatepickerComponent,
    DisplayLabelSortPipe,
    DynamicFormComponent,
    EmailComposerComponent,
    ExternalLinkDirective,
    FileInputComponent,
    FilterStageTypePipe,
    HasPermissionDirective,
    InputNumbersOnlyDirective,
    MailingComposerComponent,
    MailingConfirmationComponent,
    NgSelectMultiLabelTmpComponent,
    NumericTextboxComponent,
    PhonePipe,
    PrintTimePipe,
    SignatureComponent,
    SiretPipe,
    SmsComposerComponent,
    SortableDirective,
    TextEditorComponent,
    TimePipe,
    TitleTemplateDirective,
    ToastsContainerComponent,
    UniqueNaturePipe,
  ],
  exports: [
    AgePipe,
    CalendarComponent,
    ConfirmationComponent,
    ConfirmEqualValidatorDirective,
    DatepickerComponent,
    DisplayLabelSortPipe,
    DynamicFormComponent,
    ExternalLinkDirective,
    FileInputComponent,
    FilterStageTypePipe,
    HasPermissionDirective,
    InputNumbersOnlyDirective,
    MailingConfirmationComponent,
    NgSelectMultiLabelTmpComponent,
    NumericTextboxComponent,
    PhonePipe,
    PrintTimePipe,
    SiretPipe,
    SortableDirective,
    TextEditorComponent,
    TimePipe,
    TitleTemplateDirective,
    ToastsContainerComponent,
    UniqueNaturePipe,
  ],
  imports: [
    CalendarModule.forRoot(
      { provide: DateAdapter, useFactory: momentAdapterFactory },
      { dateFormatter: { provide: CalendarDateFormatter, useClass: CalendarMomentDateFormatter } },
    ),
    CommonModule,
    FontAwesomeModule,
    FormsModule,
    NgbModule,
    NgSelectModule,
    NgSignaturePadModule,
    QuillModule.forRoot({ modules: { syntax: true, clipboard: true, history: true } }),
    ReactiveFormsModule,
  ],
  providers: [
    NgbTooltipConfig,
    {
      provide: MOMENT,
      useValue: moment,
    },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class SharedModule {}
